import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Text, SvgIcon } from 'Components/Base';

const FeedbackSuccess = (props) => {
  const { t } = useTranslation('feedback');

  return (
    <Flex flexDirection="column" alignItems="center" {...props}>
      <SvgIcon icon={SvgIcon.ICON_LIST.CHECK_CIRCLE} color="success" size="72px" />
      <Text fontWeight={'bold'} mt={4}>
        {t('IMPROVEMENT_AND_SATISFIED.COMPLETE')}
      </Text>
    </Flex>
  );
};

export default FeedbackSuccess;
